import React from 'react'
import { Form } from 'antd'
import { Section, Toggle } from './components'
import { Field } from './styles'
import useAutoSave from './useAutoSave'

export type OrderParamsValues = {
  partnerId: string
  partnerCapitalDeposit: string
  taxOption: string
  paidByPartner: string
}

export const ORDER_PARAMS_EMPTY: OrderParamsValues = {
  partnerId: '',
  partnerCapitalDeposit: '',
  taxOption: '',
  paidByPartner: '',
}

type Props = {
  initialValues: OrderParamsValues
  legalFormalityId: number
  indyPartners: { id: string; name: string }[]
}

const OrderParamsSection = ({
  initialValues,
  legalFormalityId,
  indyPartners,
}: Props) => {
  const [form] = Form.useForm<OrderParamsValues>()
  const { status, onValuesChange } = useAutoSave({
    form,
    legalFormalityId,
    initialValues,
  })

  return (
    <Section title="Paramètres de commande" defaultOpen status={status}>
      <Form
        form={form}
        onValuesChange={onValuesChange}
        layout="vertical"
        style={{ display: 'flex', flexDirection: 'column', gap: 16 }}
      >
        <Field>
          <label>Partner</label>
          <Form.Item name="partnerId" noStyle>
            <select>
              <option value="">— aucun —</option>
              {indyPartners.map(p => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </Form.Item>
        </Field>
        <Field>
          <label>Dépôt capital partenaire</label>
          <Form.Item
            name="partnerCapitalDeposit"
            noStyle
            getValueProps={v => ({ checked: v === 'true' })}
            normalize={v => (v ? 'true' : '')}
          >
            <Toggle />
          </Form.Item>
        </Field>
        <Field>
          <label>Option fiscale</label>
          <Form.Item name="taxOption" noStyle>
            <select>
              <option value="">—</option>
              <option value="LMNP">LMNP</option>
              <option value="IS">IS</option>
            </select>
          </Form.Item>
        </Field>
        <Field>
          <label>Payé par partenaire</label>
          <Form.Item
            name="paidByPartner"
            noStyle
            getValueProps={v => ({ checked: v === 'true' })}
            normalize={v => (v ? 'true' : '')}
          >
            <Toggle />
          </Form.Item>
        </Field>
      </Form>
    </Section>
  )
}

export default OrderParamsSection
